var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"social-connect"},[_c('a',{staticClass:"social-btn social-btn--google",on:{"click":function($event){return _vm.socialClickHandler('Google')}}},[_vm._v("SIGN IN WITH GOOGLE")])])
}
var staticRenderFns = []

export { render, staticRenderFns }